import Colors from 'modules/Colors'
import { CSSProperties, SVGProps } from 'react'

interface DeezerFlatIconProps extends SVGProps<SVGSVGElement> {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const DeezerFlatIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 40,
    onClick
}: DeezerFlatIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            onClick={onClick}
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M36.0018 9.52347H29.0817V13.5846H36.0018V9.52347Z" fill={color}/>
            <path d="M36.0018 15.1541H29.0817V19.2153H36.0018V15.1541Z" fill={color}/>
            <path d="M36.0018 20.7847H29.0817V24.8459H36.0018V20.7847Z" fill={color}/>
            <path d="M10.9184 26.4154H3.99829V30.4765H10.9184V26.4154Z" fill={color}/>
            <path d="M19.2742 26.4154H12.3541V30.4765H19.2742V26.4154Z" fill={color}/>
            <path d="M27.646 26.4154H20.7259V30.4765H27.646V26.4154Z" fill={color}/>
            <path d="M36.0018 26.4154H29.0817V30.4765H36.0018V26.4154Z" fill={color}/>
            <path d="M27.646 20.7847H20.7259V24.8459H27.646V20.7847Z" fill={color}/>
            <path d="M19.2742 20.7847H12.3541V24.8459H19.2742V20.7847Z" fill={color}/>
            <path d="M19.2742 15.1541H12.3541V19.2153H19.2742V15.1541Z" fill={color}/>
        </svg>
    )
}

export default DeezerFlatIcon
